var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableIconModalCheckin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.85,
    height: 17.807,
    viewBox: "0 0 25.85 17.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.85,
    height: 17.807,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeti\\xE7\\xE3o_de_grade_1",
    "data-name": "Repeti\\xE7\\xE3o de grade 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-650.194 -411.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2583",
    "data-name": "Caminho 2583",
    d: "M254.374,243.255a.4.4,0,0,1-.269.478.356.356,0,0,1-.424-.3l-1.311-6.618h-5.135l-1.662,6.64a.364.364,0,0,1-.341.292.328.328,0,0,1-.1-.015.41.41,0,0,1-.245-.494l.666-6.692-.667-7.165a.549.549,0,0,1-.011-.068l.257-1.643h.316l.552,2.242,1.235,6.1h5.418a.615.615,0,0,1,.5.375Zm-7.848-10.91c-.181-.906-.366-2.05-.523-2.861.017-.144-1.148.439-1.113,0,.146-1.587.536-2.424.311-2.481-.009,0,.372.265.363.263l-.2.162Zm3.818,2.968c-.923,0-.768.392-1.245.7l3.435.216A3.946,3.946,0,0,0,250.345,235.313Zm13.5,8.041-3.169-2.205a.985.985,0,0,0-.214-.107l3.656-7.87h-8.184l3.657,7.87a1,1,0,0,0-.216.108l-3.168,2.205c-.358.249-.406.453-.108.453a2.584,2.584,0,0,0,1.192-.453l2.085-1.451a1.227,1.227,0,0,1,1.3,0l2.086,1.451a2.583,2.583,0,0,0,1.192.453C264.254,243.807,264.205,243.6,263.847,243.354ZM250.727,232.8h18.6a.411.411,0,0,0,.383-.431v-.027a.41.41,0,0,0-.383-.431h-18.6a.41.41,0,0,0-.382.431v.027A.41.41,0,0,0,250.727,232.8Z",
    transform: "translate(405.833 184.608)",
    fill: "#21e270",
    stroke: "#21e270",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconModalCheckin);
export default __webpack_public_path__ + "static/media/table-icon-modal-checkin.dcd18394.svg";
export { ForwardRef as ReactComponent };